import React from 'react'
import { Container, IconCircle, Title, HomeButton } from './style'
import { Images } from 'APP/Themes'
import { useTheme } from 'styled-components/native'
import I18n from 'APP/I18n'

type HomeBannerButtonProps = {
  onPress: () => void
}

const HomeBannerButton = ({ onPress }: HomeBannerButtonProps) => {
  const theme = useTheme()
  return (
    <Container testID="HOME_BANNER_BUTTON_CONTAINER">
      <HomeButton onPress={onPress} testID="HOME_BANNER_BUTTON">
        <IconCircle testID="HOME_BANNER_BUTTON_ICON_CIRCLE">
          <Images.arrowLeftRoundedIcon
            width={theme.metrics.icon.small}
            height={theme.metrics.icon.small}
            color={theme.colors.homeBannerBg}
          />
        </IconCircle>
        <Title testID="HOME_BANNER_BUTTON_TITLE">{I18n.t('HomeBannerButton.home')}</Title>
      </HomeButton>
    </Container>
  )
}

export default HomeBannerButton
